/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdminConversationRateResponse } from './';
import {
    AdminConversationRateResponseFromJSON,
    AdminConversationRateResponseFromJSONTyped,
    AdminConversationRateResponseToJSON,
} from './';
import type { AdminProfileAlertResponse } from './';
import {
    AdminProfileAlertResponseFromJSON,
    AdminProfileAlertResponseFromJSONTyped,
    AdminProfileAlertResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminDetailsResponse
 */
export interface AdminDetailsResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDetailsResponse
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDetailsResponse
     */
    explanation: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDetailsResponse
     */
    notSeenEnoughBonus: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDetailsResponse
     */
    families: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDetailsResponse
     */
    categories: Array<string>;
    /**
     * 
     * @type {Array<AdminProfileAlertResponse>}
     * @memberof AdminDetailsResponse
     */
    alerts: Array<AdminProfileAlertResponse>;
    /**
     * 
     * @type {AdminConversationRateResponse}
     * @memberof AdminDetailsResponse
     */
    viewConversationRate?: AdminConversationRateResponse;
    /**
     * 
     * @type {AdminConversationRateResponse}
     * @memberof AdminDetailsResponse
     */
    conversationInvoiceRate?: AdminConversationRateResponse;
    /**
     * 
     * @type {AdminConversationRateResponse}
     * @memberof AdminDetailsResponse
     */
    conversationQuotationRate?: AdminConversationRateResponse;
    /**
     * 
     * @type {Date}
     * @memberof AdminDetailsResponse
     */
    lastModificationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDetailsResponse
     */
    lastConnectionDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDetailsResponse
     */
    visible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDetailsResponse
     */
    reactivable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDetailsResponse
     */
    hopRecommended?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDetailsResponse
     */
    hopDisliked?: boolean;
}

/**
 * Check if a given object implements the AdminDetailsResponse interface.
 */
export function instanceOfAdminDetailsResponse(value: object): value is AdminDetailsResponse {
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('explanation' in value) || value['explanation'] === undefined) return false;
    if (!('notSeenEnoughBonus' in value) || value['notSeenEnoughBonus'] === undefined) return false;
    if (!('families' in value) || value['families'] === undefined) return false;
    if (!('categories' in value) || value['categories'] === undefined) return false;
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    if (!('lastModificationDate' in value) || value['lastModificationDate'] === undefined) return false;
    if (!('lastConnectionDate' in value) || value['lastConnectionDate'] === undefined) return false;
    if (!('visible' in value) || value['visible'] === undefined) return false;
    if (!('reactivable' in value) || value['reactivable'] === undefined) return false;
    return true;
}

export function AdminDetailsResponseFromJSON(json: any): AdminDetailsResponse {
    return AdminDetailsResponseFromJSONTyped(json, false);
}

export function AdminDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'score': json['score'],
        'explanation': json['explanation'],
        'notSeenEnoughBonus': json['notSeenEnoughBonus'],
        'families': json['families'],
        'categories': json['categories'],
        'alerts': ((json['alerts'] as Array<any>).map(AdminProfileAlertResponseFromJSON)),
        'viewConversationRate': json['viewConversationRate'] == null ? undefined : AdminConversationRateResponseFromJSON(json['viewConversationRate']),
        'conversationInvoiceRate': json['conversationInvoiceRate'] == null ? undefined : AdminConversationRateResponseFromJSON(json['conversationInvoiceRate']),
        'conversationQuotationRate': json['conversationQuotationRate'] == null ? undefined : AdminConversationRateResponseFromJSON(json['conversationQuotationRate']),
        'lastModificationDate': (new Date(json['lastModificationDate'])),
        'lastConnectionDate': (new Date(json['lastConnectionDate'])),
        'visible': json['visible'],
        'reactivable': json['reactivable'],
        'hopRecommended': json['hopRecommended'] == null ? undefined : json['hopRecommended'],
        'hopDisliked': json['hopDisliked'] == null ? undefined : json['hopDisliked'],
    };
}

export function AdminDetailsResponseToJSON(value?: AdminDetailsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'score': value['score'],
        'explanation': value['explanation'],
        'notSeenEnoughBonus': value['notSeenEnoughBonus'],
        'families': value['families'],
        'categories': value['categories'],
        'alerts': ((value['alerts'] as Array<any>).map((v) => AdminProfileAlertResponseToJSON(v))),
        'viewConversationRate': AdminConversationRateResponseToJSON(value['viewConversationRate']),
        'conversationInvoiceRate': AdminConversationRateResponseToJSON(value['conversationInvoiceRate']),
        'conversationQuotationRate': AdminConversationRateResponseToJSON(value['conversationQuotationRate']),
        'lastModificationDate': ((value['lastModificationDate']).toISOString().substring(0,10)),
        'lastConnectionDate': ((value['lastConnectionDate']).toISOString().substring(0,10)),
        'visible': value['visible'],
        'reactivable': value['reactivable'],
        'hopRecommended': value['hopRecommended'],
        'hopDisliked': value['hopDisliked'],
    };
}

